export function getLocationsBasedOnStatus(data) {

    if (data?.pricingType === 'fixed' || data?.pricingType === 'hourly') {
        return {
            pickUpLocation: {
                location: {
                    location: data?.startLocation,
                    lat: data?.startLat,
                    lng: data?.startLng,
                }
            },
            dropLocation: {
                location: {
                    location: data?.endLocation,
                    lat: data?.endLat,
                    lng: data?.endLng,
                }
            }
        };
    }

    return { pickUpLocation: null, dropLocation: null };
}